// 查看状态
export const CONSUME_INTERVIEW_STATUS = [
  { label: '查看全部', value: -1 },
  { label: '只看待审核', value: 0 },
  // { label: '审核通过', value: 1 },
  // { label: '审核不通过', value: 2 },
  { label: '只看已审核', value: -2 }
]

// 权益类型
export const JURISDICTION_TYPE = {
  0: '无权益',
  1: '体验权益',
  2: '小初全科权益',
  NO_JUR: 0,
  EXPER_JUR: 1,
  ALL_JUR: 2
}

// 权益包类型
export const RIGHT_PACKAGE_TYPE = {
  10: '体验权益',
  11: '一类权益',
  12: '二类权益',
  13: '一年有效全科权益',
  14: '三年有效全科权益',
  15: '永久有效全科权益',
  16: '高中一类权益',
  17: '高中二类权益',
  18: '次卡权益',
  1000: '全科权益'
}

// 审核状态
export const AUDIT_STATUS = {
  0: '待审核',
  1: '审核通过',
  2: '审核不通过',
  WAIT: 0,
  APPROVE: 1,
  REJECT: 2
}

// 更新状态类型
export const UPD_STATUS = {
  REAUDIT: 0,
  APPROVE: 1,
  NOTAPPROVE: 2
}

// 高中全科权益权益包
export const SENIOR_CARD_TYPES = [
  16, // 高中一类
  17 // 高中二类
]